import { render, staticRenderFns } from "./addUserAddress.vue?vue&type=template&id=a80b9c46"
import script from "./addUserAddress.vue?vue&type=script&lang=js"
export * from "./addUserAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports